import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { OpenInNewRounded } from "@mui/icons-material";
import { MdOutlinedFlag, MdOutlineEventSeat } from "react-icons/md";
import { Box, Link, ListItemIcon, ListItemText, MenuItem } from "@mui/material";

import { MLBAdobeScriptHeader } from "@/global/common/mlb-common/MLBAdobeScriptHeader";

export const purchaseSeatLanguages = {
  progressBarSuccessText:
    "You're good to go! Add more events or select Continue to view seating options.",
};

export const NewYorkYankeesLink = () => (
  <Link
    target="_blank"
    href="https://am.ticketmaster.com/nyyreg/"
    sx={{
      fontWeight: 500,
      color: "primary.main",
      textDecoration: "none",
    }}
  >
    Account Manager
  </Link>
);

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description:
      "Select a minimum 1 Banana Ball game and 3 New York Yankees games to continue.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to Account Manager",
    description: (
      <>
        Click Continue and connect your New York Yankees <NewYorkYankeesLink />{" "}
        using our secure Ticketmaster login.
      </>
    ),
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },

  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your <NewYorkYankeesLink /> within 24 hours
        of redemption.
      </>
    ),
  },
];

export const faqs = [];

export const NewYorkYankeesTerms = () => (
  <>
    I understand and agree to the{" "}
    <Link
      target="_blank"
      sx={{
        fontWeight: 500,
        color: "primary.main",
        textDecoration: "none",
      }}
      href="https://www.mlb.com/yankees/tickets/terms-and-conditions"
    >
      Tickets Terms & Conditions
    </Link>{" "}
    and all the following: The terms and conditions of your ticket and policies
    applicable to use are updated to address{" "}
    <Link
      target="_blank"
      sx={{
        fontWeight: 500,
        color: "primary.main",
        textDecoration: "none",
      }}
      href="https://urldefense.com/v3/__https:/links.mlb.mlbemail.com/s/c/aSJbz_BoMO1CyFE-hqtB6Gzelvcygv_QpDgGABmA6Ym5ZzkHOFBBl_FXvk0_sFYSlKn9asfnCuv_HHYCSf2xvAuccz91KI_9ajBrI1OilqiafuPHEjCN07olvNwdPzAQGjthSC7I4LAQsh1PQ10w8aqylEfsRHFUTlCefBAdsNoTMWW2389FrjN2sBSLyhMES_Fxf3Heip8eyhKyD-qXcScPn_dkmxmp88Fbxa-WK5zTKtb6yoSj8BZJCDefMzz-0xIUKr2eyIqBh6cmZF4yWr4XNCrJ4FSFA6nVe1PFhltS5e8Qk5_lsfg1Qwsd6OGGFjD2oeL9s3K29K8kzdooJgg-wDo6cWu6skZC1cUUjlp9v5KkRGODPOqVkR7SBBETIfS7ZVQpwBxS49DaiczYPS2xxT6gxkbkMwI_ZHBD31yZ27E/FV3JUu83ti-U32e_vNzNjXhw1sMXf__R/8__;!!CtcW_5ORIF_ZIHY!PSLhhAQ3o4p_VusddYyh2Ma_fBD5nIU7W86GnRVX-QVVcEYn3xnaEEx2ZqgZUa9L7ZJ2yNZ72v0_s4SFE5ZnFg$"
    >
      COVID-19 and health & safety
    </Link>
    . By purchasing a New York Yankees ticket, you accept these Terms and
    Conditions and policies applicable to use. Further, due to the COVID-19
    pandemic, scheduling may be impacted; games may be canceled, rescheduled, or
    postponed or games may be held with limited capacity. Upon completing your
    purchase by selecting “Checkout” you acknowledge and agree that your credit
    card will be charged. Time, opponent, date and team rosters and lineups are
    subject to change. The number of innings in a regulation game shall be
    determined by MLB and may be shortened in accordance with MLB rules.
    Licensor makes no representation, warranty and/or guarantee that nine (9)
    innings will be played in any regulation game. In connection with your
    purchase, you will receive ticket-related commercial emails from{" "}
    <Link
      target="_blank"
      sx={{
        fontWeight: 500,
        color: "primary.main",
        textDecoration: "none",
      }}
      href="http://yankees.com/"
    >
      yankees.com
    </Link>
    . You may unsubscribe at any time. By clicking “Checkout”, you agree to the{" "}
    <Link
      target="_blank"
      sx={{
        fontWeight: 500,
        color: "primary.main",
        textDecoration: "none",
      }}
      href="https://www.mlb.com/app/ballpark/official-information/privacy-policy"
    >
      MLB Privacy Policy
    </Link>{" "}
    and{" "}
    <Link
      target="_blank"
      sx={{
        fontWeight: 500,
        color: "primary.main",
        textDecoration: "none",
      }}
      href="https://www.mlb.com/app/ballpark/official-information/terms-of-use"
    >
      Terms of Use
    </Link>
    . There are no refunds or exchanges.
  </>
);

export const NewYorkYankeesTCListItems = () => (
  <Box>
    <MenuItem
      onClick={() => {
        window.open(
          "https://www.mlb.com/yankees/tickets/terms-and-conditions",
          "_blank"
        );
      }}
    >
      <ListItemIcon>
        <OpenInNewRounded fontSize="small" />
      </ListItemIcon>
      <ListItemText>New York Yankees</ListItemText>
    </MenuItem>

    <MenuItem
      onClick={() => {
        window.open(
          "https://www.mlb.com/app/ballpark/official-information/privacy-policy",
          "_blank"
        );
      }}
    >
      <ListItemIcon>
        <OpenInNewRounded fontSize="small" />
      </ListItemIcon>
      <ListItemText>MLB Privacy Policy</ListItemText>
    </MenuItem>

    <MenuItem
      onClick={() => {
        window.open(
          "https://www.mlb.com/app/ballpark/official-information/terms-of-use",
          "_blank"
        );
      }}
    >
      <ListItemIcon>
        <OpenInNewRounded fontSize="small" />
      </ListItemIcon>
      <ListItemText>MLB Terms of Use</ListItemText>
    </MenuItem>
  </Box>
);

export function AnalyticsHeader() {
  return (
    <>
      <MLBAdobeScriptHeader />
    </>
  );
}
